export enum IntegrationType {
  Auw = 'Auw',
  Credit = 'Credit',
  Fees = 'Fees',
  Flood = 'Flood',
  LOS = 'Los',
  Pricing = 'Pricing',
  PropertyData = 'PropertyData',
  Title = 'Title',
  Underwrite = 'Underwrite',
  VOA = 'VOA',
  VOIE = 'VOIE',
}

export enum IntegrationVendor {
  Argyle = 'Argyle',
  Equifax = 'Equifax',
  Ernst = 'Ernst',
  Experian = 'Experian',
  Factual = 'Factual',
  FannieMae = 'FannieMae',
  FreddieMac = 'FreddieMac',
  Gateless = 'Gateless',
  InformativeResearch = 'InformativeResearch',
  MeridianLink = 'MeridianLink',
  Mezzo = 'Mezzo',
  None = 'None',
  RatesBoard = 'RatesBoard',
  Resend = 'Resend',
  SmartFees = 'SmartFees',
  Snap = 'Snap',
  Truework = 'Truework',
  Truv = 'Truv',
  Vesta = 'Vesta',
  Xactus = 'Xactus',
}

export enum IntegrationStatus {
  Unknown,
  Active,
  Unverified,
  Disabled,
}
